export default {
  props: {
    label: String,
    comment: String,
    tooltip: [String, Object],
    required: Boolean,
    validationMessage: String,
    isHorizontal: Boolean,
    showRemove: Boolean,
    helperText: String,
  },

  methods: {
    emitRemove() {
      this.$emit('remove')
    },
  },
}
